import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@rbx/ui';
import { useTranslation } from '@rbx/intl';

interface SaveProgressErrorDialogProps {
  open: boolean;
  onContinue: () => void;
  onCancel: () => void;
}

const SaveProgressErrorDialog: React.FC<SaveProgressErrorDialogProps> = ({
  open,
  onContinue,
  onCancel,
}) => {
  const { translate } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: {
          width: '444px',
          minHeight: '194px',
        },
      }}>
      <DialogTitle variant='h4'>{translate('Label.UnableToSaveProgress')}</DialogTitle>
      <DialogContent>
        <Typography color='secondary' variant='body2'>
          {translate('Message.SaveProgressError')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant='contained' color='secondary'>
          {translate('Action.Cancel')}
        </Button>
        <Button onClick={onContinue} variant='contained' color='primaryBrand'>
          {translate('Action.Continue')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveProgressErrorDialog;
